import React, {useState, useContext, useLayoutEffect, useEffect} from 'react'
import {ControlsJson,ControlCategories} from './ControlEntries'
import style from './ControlsNewLayout.module.css'
import { useTranslation } from 'react-i18next';
import {Row, Container, Col} from 'react-bootstrap'
import {AppContext} from '../../../Resources/CanvasContextFile';
import Grow from '@material-ui/core/Grow';
import Zoom from '@material-ui/core/Zoom';
import styles from '../../LeftNavigation/DesignerControls/BasicControls.module.css';
import AddColumnIcon from '../../../Icons/AddColumnIcon';
import CustomControlBACKDROP from '../CustomControlBACKDROP/CustomControlBACKDROP';
import {useDispatch,addContexts,useSelector} from "../../../Redux"
import { checkValid, isObjectEmpty} from "../../../Resources/globalFunctions";
import { GetStateFromData } from '../../CustomHooks/CustomHooks';
//import { loadArabicImage } from '../../IFormDesignerLayout/IFormDesignerLogic';


const ControlsNewLayout = (props) => {
    const { t } = useTranslation(); 

    const contexts = GetStateFromData(props.containerId);
  
    const {openDrawer, setOpenDrawer, drawerPinned,formState2,  setOpenProperties ,activePage, imageBaseURL,openCanvasForSubform, propertyPinned } = contexts.contexts;
    const [nonDraggableElements , setNonDraggableElements ] = useState([]);
    const nonDraggableItemsList=["wizard_h","wizard_v","Menu","sidenavigation"];
    const allItemsList=["wizard_h","wizard_v","Menu","sidenavigation","textbox","password","textarea","richtexteditor","datepick","slider","listbox",
    "combo","radio","checkbox","toggle","tile","picklist","button","link","label","paragraph","table","listview","advancelistview","doclist","image",
    "imagecarousel","section","frame","tab","report","iframe","captcha"];
   
    // const AppContextVar = useContext(AppContext);
    // var formState2 ;
    // if (AppContextVar){
    //     formState2 = AppContextVar.formState2;
    //     // console.log('formState2 :: ',formState2);
    // }

    var foundjson={};
  
  function checkIfnonDraggablePresent(formStatejson ){
    
    if(formStatejson!==undefined && formStatejson!==null && allItemsList!="" && allItemsList!==undefined && allItemsList!==null ){
        if(allItemsList.includes(formStatejson.elem_type)){
          foundjson = formStatejson;
        } 
        else {
            if(formStatejson.children!==undefined && formStatejson.children!==null){
                 formStatejson.children.map(child => {
                            if(child!==null && child!==undefined && child.elem_type!==null && child.elem_type!==undefined){
                                if(allItemsList.includes(child.elem_type)){
                                  foundjson =child;
                                }
                                else if( isObjectEmpty(foundjson) ) {
                                    checkIfnonDraggablePresent(child );
                                }
                        }
                    }
                );

            }
          }
        return foundjson;
    }
  }
    // console.log("checkIfnonDraggablePresent", checkIfnonDraggablePresent(props.formData),nonDraggableElements);
    //add those elem_type here which you want to set as non-draggable
    
    const [showCustomControlBackdrop , setShowCustomControlBackdrop] = useState(false);
    useEffect(()=>{
        if(props?.marvinCheck){
            let element = document.querySelector('#ContainersId');
            if (element) {
              // Scroll to the element
              element.scrollIntoView({block:"center"});
            }
        }        
    },[document.querySelector('#ContainersId')?.length])

    useEffect(() => {
        const areSingleDroppables_present=Object.keys(checkIfnonDraggablePresent(props.formData)).length
        if((areSingleDroppables_present > 0 && nonDraggableElements.length=== 0 ) || activePage=== null ){
            setNonDraggableElements((prev) => {
                const isMenu = formState2?.containerControl === "Menu";

                const isWizard =
                  formState2?.containerControl === "wizard_v" ||
                  formState2?.containerControl === "sidenavigation" ||
                  formState2?.containerControl === "wizard_h";

                if(openCanvasForSubform === "advanceListviewFromScratch" || openCanvasForSubform === "subform" ||  isMenu || isWizard){
                    nonDraggableItemsList.push("tab")
                }
                if(openCanvasForSubform === "subform") {
                    nonDraggableItemsList.push("advancelistview")
                }
                return [...nonDraggableItemsList] });
        }
        else if(areSingleDroppables_present===0 && nonDraggableElements.length!== 0){
            setNonDraggableElements([]);
        }
    });

    function clickHandler(){

        setShowCustomControlBackdrop(!showCustomControlBackdrop);
        if(!propertyPinned)
            setOpenProperties(false);

    }

    function closeDrawerWhileDraggingAndNotPinned(){
        // console.log("dragging closeDrawerWhileDraggingAndNotPinned",'| drawerPinned :: ',drawerPinned,'|openDrawer :: ',openDrawer);
        if(drawerPinned===false){
            if(openDrawer===true){
                // console.log('dragging :: openDrawer :: ',openDrawer);
                // setOpenDrawer(false);
            }
        }
    }

    useLayoutEffect(() => {
        var allControlDivWrappers = document.getElementsByClassName("getThisControlDivWrapper");
        for(let i=0;i<allControlDivWrappers.length ; i++){
            ////console.log('allControlDivWrappers['+i+'].childNodes :: ',allControlDivWrappers[i].childNodes);
            if(allControlDivWrappers[i].childNodes[1]){
                let controlIconWrapper = allControlDivWrappers[i].childNodes[0];
                var controlIcon;
                if(controlIconWrapper && controlIconWrapper.childNodes[0]){
                    controlIcon = controlIconWrapper && controlIconWrapper.childNodes[0];
                }
                let controlNameDiv = allControlDivWrappers[i].childNodes[1];
                if(controlNameDiv.childNodes[0]){
                    let controlNameLabel = controlNameDiv.childNodes[0];
                    if(controlNameLabel.innerHTML){
                        var controlNameLength = controlNameLabel.innerHTML.length;
                        if(controlNameLength>11){
                            ////console.log('controlIcon :: ',controlIcon);
                            controlIcon.style.marginBottom = "2px";
                        }
                    }
                }
            }
        }
        
    });

    return (
        <div className={style.allControlsWrapper}>
            {
                ControlCategories.length > 0 && ControlCategories.map(
                    (categoryName , index) => {
                        let searchedArray = ControlsJson[categoryName].filter(item=>item.label.toLowerCase().includes(props.search.toLowerCase()))
                        return (
                            <div className={style.categoryWrapper}>
                                {(searchedArray.length>0) && 
                                <Container fluid>
                                    
                                    <div className={style.categorylabel} id={categoryName==="Containers" ? "ContainersId" : null}>
                                        {t(categoryName)}
                                    </div>
                                    
                                    
                                    <Row xs={3} md={3} lg={3} className={style.controlGroupWrapper}>
                                        {  
                                            searchedArray.map(
                                                control => {
                                                    var controlIcon = control['icon'];
                                                    var controlLabel = control['label'];
                                                    var controlElemType = control['elem_type'];
                                                    
                                                    if(nonDraggableElements.includes(controlElemType)){
                                                        return (
                                                            <Zoom in={true}>
                                                                <Col 
                                                                    className={style.nonDraggableElement}  
                                                                    inptype={controlElemType} 
                                                                    // onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                    // onDragStart={props.createNewElement} 
                                                                    draggable="false"
                                                                >
                                                                    <div className={style.ControlsWrapperNonDraggable + ' getThisControlDivWrapper'} 
                                                                    inptype={controlElemType} 
                                                                    // onDragStart={props.createNewElement} draggable="true" 
                                                                    // onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                    >
                                                                        <div className={style.IconWrapper}>
                                                                            {controlIcon? <div className={style.iconDiv} >{controlIcon}</div> : <div className={style.squareIcon} />}
                                                                        </div>
                                                                        <div className={style.controlName + ' controlNameDiv'}>
                                                                            <div className={style.controlLabel+' controlNameLabel'}>
                                                                                {t(controlLabel)}

                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </Col>
                                                            </Zoom>
                                                        );
                                                    } 
                                                    else {
                                                        return (
                                                            <Zoom in={true}>
                                                                <Col 
                                                                    className={style.customCol}  
                                                                    inptype={controlElemType} 
                                                                    controlLabel={controlLabel}
                                                                    onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                    onDragStart={props.createNewElement} 
                                                                    draggable="true" 
                                                                >
                                                                    <div 
                                                                        className={style.ControlsWrapper + ' getThisControlDivWrapper'} 
                                                                        onDragStart={props.createNewElement} 
                                                                        draggable="true" 
                                                                        tabIndex={0}
                                                                        inptype={controlElemType} 
                                                                        controlLabel={controlLabel}
                                                                        onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                    >
                                                                        <div className={style.IconWrapper}
                                                                        inptype={controlElemType} 
                                                                        controlLabel={controlLabel}
                                                                        onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                        onDragStart={props.createNewElement} 
                                                                        draggable="true"
                                                                        >
                                                                            {controlIcon? <div className={style.iconDiv} 
                                                                            inptype={controlElemType} 
                                                                            controlLabel={controlLabel}
                                                                            onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                            onDragStart={props.createNewElement} 
                                                                            draggable="true"
                                                                            >{controlIcon}</div> : <div className={style.squareIcon} 
                                                                            inptype={controlElemType} 
                                                                            controlLabel={controlLabel}
                                                                            onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                            onDragStart={props.createNewElement} 
                                                                            draggable="true"
                                                                            />}
                                                                        </div>
                                                                        <div className={style.controlName + ' controlNameDiv'}
                                                                        inptype={controlElemType} 
                                                                        controlLabel={controlLabel}
                                                                        onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                        onDragStart={props.createNewElement} 
                                                                        draggable="true"
                                                                        >
                                                                            <div 
                                                                            inptype={controlElemType} 
                                                                            controlLabel={controlLabel}
                                                                            onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                                            onDragStart={props.createNewElement} 
                                                                            draggable="true"
                                                                            className={style.controlLabel+' controlNameLabel'}>
                                                                                {t(controlLabel)}

                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </Col>
                                                            </Zoom>
                                                        )
                                                    }   
                                                }    
                                                                                         
                                            )
                                        }
                                    </Row>
                                    
                                </Container> 
                                }                               
                            </div>
                        );
                        
                    }
                )
            }
            <div className={style.categoryWrapper}>
                <Container fluid>
                    <Row xs={3} md={3} lg={3} className={style.controlGroupWrapper}>
                        {
                            formState2 && formState2['customControl'] &&
                            formState2['customControl'].map(
                                control => {
                                    if (!props.search || (props.search && control.label.toLowerCase().includes(props.search.toLowerCase()))){
                                    var controlIcon = <img style={{height:"60px"}} src={require('../../../Icons/CustomControl.svg').default} 
                                                            height="26" draggable="false" alt='Custom Control'/>;
                                    var controlLabel = control['label'];
                                    var controlElemType = control['elem_type'];
                                     var controlIconSrc = `${imageBaseURL}${control['iconFile']}`;
                               //    var controlIconSrc = `${imageBaseURL}${control['iconFile']}${loadArabicImage(imageBaseURL)}}`;

                                
                                    if(nonDraggableElements.includes(controlElemType)){
                                        return (
                                            <Zoom in={true}>
                                                <Col className={style.nonDraggableElement}  inptype={controlElemType} 
                                                // onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                // onDragStart={props.createNewElement} 
                                                draggable="false">
                                                    <div className={style.ControlsWrapperNonDraggable + ' getThisControlDivWrapper'} 
                                                    inptype={controlElemType} 
                                                    controlLabel={controlLabel}
                                                    // onDragStart={props.createNewElement} draggable="true" 
                                                    // onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                    >
                                                        <div className={style.IconWrapper}>
                                                            {controlIcon? <div className={style.iconDiv} >{controlIcon}</div> : <div className={style.squareIcon} />}
                                                        </div>
                                                        <div className={style.controlName + ' controlNameDiv'}>
                                                            <div className={style.controlLabel+' controlNameLabel'}>
                                                                {t(controlLabel)} 

                                                            </div>
                                                        </div>

                                                    </div>
                                                </Col>
                                            </Zoom>
                                        );
                                    } 
                                    else {
                                        return (
                                            <Zoom in={true}>
                                                <Col className={style.customCol}  inptype={controlElemType} onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                onDragStart={props.createNewElement} 
                                                draggable="true">
                                                    <div className={style.ControlsWrapper + ' getThisControlDivWrapper'} 
                                                    onDragStart={props.createNewElement} draggable="true" 
                                                    tabIndex={0}
                                                    inptype={controlElemType} 
                                                    controlLabel={controlLabel}
                                                    onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                    >
                                                        <div className={style.IconWrapper}
                                                         onDragStart={props.createNewElement} draggable="true" 
                                                         inptype={controlElemType} 
                                                         controlLabel={controlLabel}
                                                         onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                        >
                                                            {controlIcon? <div className={style.iconDiv}
                                                             onDragStart={props.createNewElement} draggable="true" 
                                                             inptype={controlElemType} 
                                                             controlLabel={controlLabel}
                                                             onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                            >
                                                                <img alt="Img Icon" 
                                                                inptype={controlElemType}
                                                                controlLabel={controlLabel}
                                                                onDragStart={props.createNewElement} draggable="true" 
                                                                onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                               // src={require('../../../Icons/CustomControl.svg').default} 
                                                                src={controlIconSrc!==undefined && controlIconSrc.length!== 0 ? `${controlIconSrc}` :
                                                                    require('../../../Icons/CustomControl.svg').default}
                                                                style={controlIconSrc!==undefined && controlIconSrc.length!== 0 ? {'height' : '30px'}:
                                                                {'height' : '60px'}}
                                                                />
                                                            </div> : <div className={style.squareIcon} 
                                                             onDragStart={props.createNewElement} draggable="true" 
                                                             inptype={controlElemType} 
                                                             controlLabel={controlLabel}
                                                             onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                             />}
                                                        </div>
                                                        <div className={style.controlName + ' controlNameDiv'}
                                                         onDragStart={props.createNewElement} draggable="true" 
                                                         inptype={controlElemType} 
                                                         controlLabel={controlLabel}
                                                         onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                        >
                                                            <div className={style.controlLabel+' controlNameLabel'}
                                                             onDragStart={props.createNewElement} draggable="true" 
                                                             inptype={controlElemType} 
                                                             controlLabel={controlLabel}
                                                             onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                              style={{ 
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }}

  title={t(controlLabel)}
                                                            >
                                                                {t(controlLabel)} 

                                                            </div>
                                                        </div>

                                                    </div>
                                                </Col>
                                            </Zoom>
                                        )
                                    }   
                                } 
                                }                                                   
                            )
                        }

                    </Row>
                </Container>   
            </div>
            <div className={styles.addCustomControlButtonDiv}
            
            
            // onClick={()=>setShowCustomControlBackdrop(!showCustomControlBackdrop)}>
            tabIndex={0}
            onClick={()=>clickHandler()}>


                <span className={styles.addColumnIconSpan}>
                <AddColumnIcon/>
                </span>
                {t('Add Custom Control')}
            </div>
            { showCustomControlBackdrop === true ?
                <CustomControlBACKDROP setShowCustomControlBackdrop={()=> setShowCustomControlBackdrop(!showCustomControlBackdrop)}/>
                :<></>
            }
        </div>
    )
}

export default ControlsNewLayout;
